export default __webpack_public_path__ + "static/media/gold.458f655e.svg";